function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'b69f4a206616cd6a4fc2df9cce90290b': 'rgb(143, 20, 24)','e1da2387aad2710f1f4abb99f532ed9b': 'rgb(216, 205, 186)','f750206b36045a98219bb90a21ae7fc0': 'rgb(95, 107, 85)','5409598e6a85a070b879aa37cb7f0890': 'rgb(143, 133, 118)','5fca1f1ce26137d2014e9bda276a320e': 'rgb(90, 74, 61)','312ee6b77f05b59ee4f528c96e84b50e': 'rgb(125, 137, 147)','12a633c71dc8d73f8f6aedc64daa3332': 'rgb(31, 42, 54)','de6686a605a3cbd2b4f3a1a80283d360': 'rgb(31, 42, 54)','d4682cfd92721616c5b4e6bae80d09ad': 'rgb(74, 72, 68)','b2c0400de77c35fd48ea00cc532a8542': 'rgb(63, 49, 40)','5ef985ab044039ff5e9f3bea507344c8': 'rgb(180, 166, 148)','37b170b20801853704a0525695b12249': 'rgb(184, 138, 90)','6862efb4028e93ac23a6f90a9055bae8': 'rgb(137, 127, 71)',};

    this.images = {};
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
